import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/components/Main'
import ChooseBoard from '@/components/ChooseBoard'

Vue.use(Router)

export default new Router({
    routes: [{
        path: '/',
        name: 'ChooseBoard',
        component: ChooseBoard
    }, {
        path: '/:roomName',
        name: 'Main',
        component: Main
    }],
    mode: 'history'
})


// WEBPACK FOOTER //
// ./src/router/index.js